var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineGemini2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22V3c0-.41.34-.75.75-.75s.75.34.75.75v19c0 .41-.34.75-.75.75s-.75-.34-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.77 5.83 12 3.06 9.23 5.83c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06l3.3-3.3a.75.75 0 0 1 1.06 0l3.3 3.3c.29.29.29.77 0 1.06-.14.15-.34.22-.53.22s-.38-.07-.53-.22zM4.47 7.53 3 6.06 1.53 7.53c-.29.29-.77.29-1.06 0a.755.755 0 0 1 0-1.06l2-2a.75.75 0 0 1 1.06 0l2 2c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22zM22.47 7.53 21 6.06l-1.47 1.47c-.29.29-.77.29-1.06 0a.755.755 0 0 1 0-1.06l2-2a.75.75 0 0 1 1.06 0l2 2c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17.75c-4.42 0-6.75-2.33-6.75-6.75V6.04c0-.41.34-.75.75-.75s.75.34.75.75V11c0 3.58 1.67 5.25 5.25 5.25h6c3.58 0 5.25-1.67 5.25-5.25V6.04c0-.41.34-.75.75-.75s.75.34.75.75V11c0 4.42-2.33 6.75-6.75 6.75H9zM9 20.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75H9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineGemini2);
export default __webpack_public_path__ + "static/media/vuesax-outline-gemini-2.b7a28fca88816e652a9792500a876398.svg";
export { ForwardRef as ReactComponent };